import React from "react";
import {useSiteHealthAndSafetyTypeQueryQuery} from "../../generated/graphql";
import {GraphQlSelect} from "./GraphQlSelect";

export const SiteHealthAndSafetyTypeSelect = (props) => {
    const query = useSiteHealthAndSafetyTypeQueryQuery();
    return <GraphQlSelect {...props} queryResult={query} labelField="label"/>;
}
